import { LoginProjectConfiguration } from '../../../api';
import { hasUrlPath, validateMobileDeepLink } from '../../../utils';

type CallbackURLValidate = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

export const calbackURLValidatation = (values: LoginProjectConfiguration): CallbackURLValidate => {
  const error: CallbackURLValidate = {
    login_urls: []
  };

  const seenUrls = new Set<string>();
  const seenCorsUrls = new Set<string>();

  error.login_urls = values.login_urls.map((item: string) => {
    if (!item) {
      return 'app.validation.required';
    }
    if (seenUrls.has(item)) {
      return 'authorization.settings.oauth2.validation.duplicate-url';
    }
    seenUrls.add(item);
    if (!validateMobileDeepLink(item)) {
      return 'app.validation.url-invalid';
    }
    if (!item.startsWith('http://') && !item.startsWith('https://') && !item.startsWith('app://')) {
      return 'app.validation.url-invalid';
    }
    return undefined;
  });

  error.allowed_origins = values.allowed_origins.map((item: string) => {
    if (!item) {
      return 'app.validation.required';
    }
    if (seenCorsUrls.has(item)) {
      return 'authorization.settings.oauth2.validation.duplicate-url';
    }
    seenCorsUrls.add(item);
    if (!validateMobileDeepLink(item)) {
      return 'app.validation.url-invalid';
    }
    if (hasUrlPath(item)) {
      return 'app.validation.cors-origin-only';
    }
    return undefined;
  });

  if (values.fail_url && !validateMobileDeepLink(values.fail_url)) {
    error.fail_url = 'app.validation.url-invalid';
  }

  return error;
};
